export default __webpack_public_path__ + "static/media/vividime-01.efb72a62.svg";